import _ from 'lodash';
import axios from 'axios';

const validTypes = ['users', 'wires', 'statistic-events'];
export default function triggerPush(type) {
  if (!_.includes(validTypes, type)) {
    return Promise.resolve();
  }

  return axios.post(`/api/v1/lwadmin/bigquery/_trigger_push_${_.snakeCase(type)}`);
}
